var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a"},[(_vm.ing)?_c('div',[_vm._v(" "+_vm._s(_vm.times)+"后重新获取 ")]):_c('div',{on:{"click":_vm._do}},[_vm._v("点击获取验证码")])])
}
var staticRenderFns = []

export { render, staticRenderFns }